<template>
    <v-app>
        <notifications-snackbar />
        <notification-modal />
        <header-bar
            ref="headerBar"
            v-model="drawer"
            :extension="
                (!isHideSelectedSnackbars && (selectedOrderId || selectedCompanyAndAgent || selectedPrivateClient)) ||
                $breakpoint.smAndDown
            "
        >
            <template v-slot:alerts>
                <template v-if="!isHideSelectedSnackbars">
                    <add-service-snackbar v-if="selectedOrderId" />
                    <agent-search-snackbar v-if="selectedCompanyAndAgent" />
                    <private-client-search-snackbar v-if="selectedPrivateClient" />
                </template>
            </template>
        </header-bar>
        <account-balance v-if="showAccountBalance" />
        <navigation-drawer-mobile v-if="$breakpoint.smAndDown" v-model="drawer" />
        <v-main class="content" :class="{'pb-0': ['authorization', 'b2b-auth'].includes($route.name as string)}">
            <slot />
        </v-main>
        <footer-bar />
        <cookies-alert v-if="showCookiesAlert && $conf.public.showCookiesAlert" @close-dialog="closeCookieAlert" />
        <div v-if="script" v-html="script" />
    </v-app>
</template>

<script lang="ts">
    import {Component, Setup} from 'vue-facing-decorator'
    import AddServiceSnackbar from '~/components/snippets/AddServiceSnackbar.vue'
    import {EventBus, LOGOUT_REDIRECT_EVENT} from '@/utils/event-bus'
    import HeaderBar from '~src/components/headerBar.src'
    import FooterBar from '~src/components/footerBar.src'
    import {BaseLayout} from '@/components/BaseLayout.vue'
    import AgentSearchSnackbar from '@/components/snippets/AgentSearchSnackbar.vue'
    import NavigationDrawerMobile from '~src/components/snippets/navigationDrawerMobile.src'
    import NotificationsSnackbar from '@/components/NotificationsSnackbar.vue'
    import CookiesAlert from '~src/components/CookiesAlert.vue'
    import NotificationModal from '@/components/modals/NotificationModal.vue'
    import PrivateClientSearchSnackbar from '@/components/snippets/PrivateClientSearchSnackbar.vue'
    import {useGoTo} from 'vuetify'
    import AccountBalance from '@/components/account/AccountBalance.vue'

    // TODO [P1] Deprecated - use default with meta unwrapped
    @Component({
        components: {
            PrivateClientSearchSnackbar,
            NotificationModal,
            CookiesAlert,
            NotificationsSnackbar,
            NavigationDrawerMobile,
            AgentSearchSnackbar,
            HeaderBar,
            FooterBar,
            AddServiceSnackbar,
            AccountBalance,
        },
    })
    export class BlankLayout extends BaseLayout {
        @Setup(() => useGoTo()) goTo

        created() {
            useNuxtApp().vueApp.provide('goTo', this.goTo)
        }

        async mounted() {
            EventBus.$on(LOGOUT_REDIRECT_EVENT, () => {
                if (this.$toast) {
                    this.$toast.error(this.$t('authorization_timeout'))
                }
            })
            useNuxtApp().vueApp.provide('layoutRefs', this.$refs)
            this.restored = !!(await this.$store.restored)
        }

        closeCookieAlert() {
            persistentStore.SET_COOKIE_ALERT_SHOWN(true)
        }

        get script() {
            return cmsStore.layoutSettings.script
        }

        get selectedOrderId() {
            return persistentStore.selectedOrderId
        }

        get selectedCompanyAndAgent() {
            return persistentStore.selectedCompanyAndAgent
        }

        get isHideSelectedSnackbars() {
            return (
                this.$route.name === 'order-details' ||
                this.$route.name === 'company-client-profile' ||
                this.$route.name === 'companyClient'
            )
        }

        get selectedPrivateClient() {
            return persistentStore.selectedPrivateClient
        }

        get showCookiesAlert() {
            return this.restored ? !persistentStore.cookieAlertShown : false
        }

        get showAccountBalance() {
            return (
                (this.isAgency || this.isCorporate) && ['director', 'supervisor', 'support'].includes(this.personRole)
            )
        }

        get isAgency() {
            return authStore.isAgency
        }

        get isCorporate() {
            return authStore.isCorporate
        }

        get personRole() {
            return authStore.personRole
        }
    }

    export default BlankLayout
</script>
